import { useEffect } from 'react';
import { generateCorrelationId, setCorrelationId } from '@/lib/correlationId';
import axios from 'axios';

export function useDatadogCorrelation() {
  useEffect(() => {
    const correlationId = generateCorrelationId();
    setCorrelationId(correlationId);

    const headers = axios.defaults.headers.common;
    headers['X-Correlation-ID'] = correlationId;
    headers['X-Request-ID'] = correlationId;

    if (typeof window !== 'undefined' && (window as any).datadogRum) {
      (window as any).datadogRum.setRumGlobalContext({
        correlationid: correlationId,
      });
    }
  }, []);
}
